var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_233)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.294922H513V342.288H0V0.294922Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.294922H513V68.6913H0V0.294922ZM0 273.891H513V342.288H0V273.891ZM0 137.088H513V205.484H0V137.088Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.294922H204.453V204.747H0V0.294922Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.225 48.9907L115.511 89.8824H158.511L123.725 115.158L137.011 156.051L102.225 130.778L67.4383 156.051L80.7272 115.158L45.9414 89.8824H88.9382L102.225 48.9907Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.291016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/TG.bfc4f6ba633713d295c7b8f4e9ed3c45.svg";
export { ForwardRef as ReactComponent };